
export const checkForUpdate = () => {
  <></>
}